/* Quicksilver alternatief + Gelijkwaardig onderdeel (Bouwmeester Watersport, 20-10-2026).

   De Supabase Edge Function 'alternatieven' (alleen lezen) zegt WELKE producten een alternatief zijn, plus de
   teksten die Shopify niet kent (voorwaarde, doornummering). Het kaartje zelf komt van het thema: per alternatief
   haalt dit script /products/<handle>?view=qs-kaart op (templates/product.qs-kaart.liquid = snippets/card-product),
   dus met de foto, prijs (ook B2B), voorraadmelding en snel-toevoegen van de winkel. Het vak verschijnt pas als die
   kaartjes er staan en de prijsapp hun prijs berekend heeft (22-10-2026: niets verspringt meer); wat niet op tijd
   klaar is, of als het template ontbreekt, krijgt een eenvoudig kaartje uit de gegevens van de functie.

   - productpagina: uitklaprij "Alternatief" boven Specificaties, met kaartjes (Quicksilver, gelijkwaardig en op een
     Quicksilver-pagina ook de originele onderdelen die hij vervangt). Catalogusnummers zonder bestelbare pagina
     staan eronder als tekst ("Past ook als vervanging voor"). Is het onderdeel niet meer leverbaar (NLA, geen
     voorraad, geen opvolger) en is er een Quicksilver-alternatief, dan verdwijnt de koopknop en staat daar een
     melding met een link naar die rij (plan B4).
   - zoekpagina: in de resultatenkolom onder de productkaartjes, een balk "Alternatieven" in de stijl van de balk met
     het aantal resultaten en daaronder de kaartjes in het raster van de zoekresultaten, in beide richtingen
     (21-10-2026). De snippet zet de houder boven de resultaten; dit script verplaatst hem.
   - part scanner: een pijltje bij elk onderdeel met een alternatief, dat een vakje openklapt (plan B7), met
     compacte eigen kaartjes in de stijl van de scanner (geen extra aanvragen naar de winkel). Leest de onderdelen
     uit window.tekeningenWacht (zoals tekeningen-in-scanner.js); de scanner zelf blijft ongewijzigd.

   Alleen bestelbare doelen komen uit de functie. Teksten: nooit "origineel", "OEM" of "identiek" bij Quicksilver.
   Geladen door snippets/qs-alternatief.liquid. */
(function () {
  'use strict';
  // Opnieuw uitgevoerd (tweede snippet op de pagina, quick-add, theme editor): alleen nieuwe houders verwerken.
  if (window.qsAlternatief) { window.qsAlternatief.init(); return; }

  var T = {
    kopEen: 'Alternatief',
    kopMeer: 'Alternatieven',
    kopVervangt: 'Past als vervanging voor',
    kopVervangtOok: 'Past ook als vervanging voor',
    qsUitleg: 'Quicksilver alternatief — past als vervanging voor {nr}',
    gwUitleg: 'Gelijkwaardig onderdeel — uitwisselbaar met {nr}',
    ogUitleg: 'Origineel onderdeel — {nr} past als vervanging hiervoor',
    boek: 'In de catalogus als {nr}; dit is het huidige nummer.',
    via: {
      voorganger: 'Volgens de catalogus voor {nr}, de voorganger van dit nummer. Controleer of het op uw motor past.',
      opvolger: 'Volgens de catalogus voor {nr}, de opvolger van dit nummer. Controleer of het op uw motor past.',
      verwant: 'Volgens de catalogus voor {nr}. Controleer of het op uw motor past.'
    },
    letOp: 'Let op: ',
    nla: 'Dit onderdeel is niet meer leverbaar.',
    nlaLink: 'Bekijk het Quicksilver-alternatief',
    nu: 'nu {nr}',
    zoekKop: 'Alternatieven',
    pijl: 'Alternatief',
    pijlMeer: 'Alternatieven ({n})',
    btwIncl: 'incl. BTW',
    btwExcl: 'excl. BTW'
  };

  var API = null, KOP = {}, VOORRAAD = {};
  var IS_B2B = document.body.classList.contains('customer-b2b');
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Adres, sleutel en voorraadteksten staan op elke houder (zelfde snippet); de eerste is genoeg.
  function instellingen(h) {
    if (API) return;
    API = h.getAttribute('data-api');
    KOP = { apikey: h.getAttribute('data-key') };
    try { VOORRAAD = JSON.parse(h.getAttribute('data-voorraad') || '{}'); } catch (e) { VOORRAAD = {}; }
  }

  // ── hulpjes ────────────────────────────────────────────────────────────────
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Yamaha-nummers staan zonder streepjes in de catalogus; tonen zoals op de site (zelfde regel als de scanner).
  function nummer(a) {
    return /^[A-Z0-9]{12}$/.test(a || '') ? a.slice(0, 3) + '-' + a.slice(3, 8) + '-' + a.slice(8, 10) + '-' + a.slice(10) : (a || '');
  }
  function naamVan(merk, nr) { return (merk === 'Mercury' ? 'Quicksilver' : merk) + ' ' + nummer(nr); }
  function merkNr(merk, nr) { return merk + ' ' + nummer(nr); }
  // Prijzen uit de catalogus zijn excl. btw. Zelfde regel als de part scanner: B2C incl. 21% btw,
  // B2B excl. btw met de 10% korting van de B2B-app (doorgestreept de prijs zonder korting).
  function euro(p) {
    if (p == null) return '';
    var n = Number(p);
    if (IS_B2B) {
      return '<s class="qs-alt__was">€ ' + n.toFixed(2).replace('.', ',') + '</s> € ' +
        (n * 0.9).toFixed(2).replace('.', ',') + ' <span class="qs-alt__btw">' + T.btwExcl + '</span>';
    }
    return '€ ' + (n * 1.21).toFixed(2).replace('.', ',') + ' <span class="qs-alt__btw">' + T.btwIncl + '</span>';
  }
  function tekst(paar, reserve) {
    var t = paar && paar[0] && !/products\.product\./.test(paar[0]) ? paar[0] : paar && paar[1];
    return t && !/products\.product\./.test(t) ? t : reserve;
  }
  // Voorraadmelding zoals op de rest van de site; doelen zijn altijd bestelbaar (nooit NLA).
  function voorraad(d) {
    var m = d.eigen_voorraad ? ['ok', tekst(VOORRAAD.eigen, 'Op voorraad')]
      : d.partner_fallback ? ['ok', tekst(VOORRAAD.partner, '2-5 dagen levertijd')]
      : ['op', tekst(VOORRAAD.langer, 'Langere levertijd')];
    return '<span class="qs-alt__tag qs-alt__tag--' + m[0] + '"><span class="qs-alt__stip" aria-hidden="true"></span>' + esc(m[1]) + '</span>';
  }
  function haal(pad, opties) {
    // al gestart door de snippet tijdens het laden van de pagina; mislukt die, dan gewoon opnieuw
    var vooraf = !opties && window.qsVooraf && window.qsVooraf[pad];
    if (vooraf) {
      delete window.qsVooraf[pad];
      return vooraf.catch(function () { return haal(pad); });
    }
    return fetch(API + pad, opties || { headers: KOP }).then(function (r) {
      if (!r.ok) throw new Error('alternatieven ' + r.status);
      return r.json();
    });
  }
  function doel(nieuwTab) { return nieuwTab ? ' target="_blank" rel="noopener"' : ''; }
  function variantVan(url) { var m = /\/variants\/(\d+)/.exec(url || ''); return m ? m[1] : null; }
  // Shopify-foto's verkleind ophalen (kaartje is klein); andere adressen ongewijzigd.
  function klein(u) {
    return /cdn\.shopify\.com|\/cdn\/shop\//.test(u) ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=300' : u;
  }

  // ── kaartjes ───────────────────────────────────────────────────────────────
  // Eenvoudig kaartje uit de gegevens van de functie: meteen zichtbaar, en het enige kaartje in de scanner.
  function eigenKaart(d, soort, nieuwTab) {
    var titel = soort === 'qs' ? naamVan('Mercury', d.nummer) : merkNr(d.merk, d.nummer);
    return '<a class="qs-mini" href="' + esc(d.url) + '"' + doel(nieuwTab) + '>' +
      '<span class="qs-mini__beeld">' +
        // lui laden alleen in de scanner; op de product- en zoekpagina is het vak eerst verborgen en moet de foto er al zijn
        (d.afbeelding ? '<img src="' + esc(klein(d.afbeelding)) + '" alt="' + esc(titel) + '"' + (nieuwTab ? ' loading="lazy"' : '') + '>' : '') +
      '</span>' +
      '<span class="qs-mini__tekst">' +
        '<span class="qs-mini__titel">' + esc(titel) + '</span>' +
        (d.naam ? '<span class="qs-mini__naam">' + esc(d.naam) + '</span>' : '') +
        '<span class="qs-mini__prijs">' + euro(d.prijs) + '</span>' + voorraad(d) +
      '</span></a>';
  }
  // De regels onder het kaartje: wat voor alternatief het is, en wat de catalogus erbij zegt.
  function uitlegHTML(d, soort, voor, paginaNr) {
    var hoofd = soort === 'qs' ? T.qsUitleg.replace('{nr}', esc(voor))
      : soort === 'gw' ? T.gwUitleg.replace('{nr}', esc(voor))
      : T.ogUitleg.replace('{nr}', esc(paginaNr));
    var via = d.via ? (T.via[d.via.richting] || T.via.verwant).replace('{nr}', esc(merkNr(d.via.merk, d.via.nummer))) : '';
    return '<div class="qs-kaarten__uitleg">' + hoofd + '</div>' +
      (d.boek ? '<div class="qs-kaarten__extra">' + T.boek.replace('{nr}', esc(merkNr(d.boek.merk, d.boek.nummer))) + '</div>' : '') +
      (d.verpakking ? '<div class="qs-kaarten__extra">' + esc(d.verpakking) + '</div>' : '') +
      (d.voorwaarde ? '<div class="qs-kaarten__extra qs-kaarten__extra--let">' + T.letOp + esc(d.voorwaarde) + '</div>' : '') +
      (via ? '<div class="qs-kaarten__extra">' + via + '</div>' : '');
  }
  // Alle alternatieven als kaartjes: Quicksilver, gelijkwaardig en (op een Quicksilver-pagina) de originelen.
  function doelen(b) {
    return (b.quicksilver || []).map(function (d) { return [d, 'qs']; })
      .concat((b.gelijkwaardig || []).map(function (d) { return [d, 'gw']; }))
      .concat((b.origineel || []).map(function (d) { return [d, 'og']; }));
  }
  // klasse: extra klasse voor het <li> (zoekpagina: grid__item van het resultatenraster)
  function itemHTML(d, soort, voor, paginaNr, nieuwTab, klasse) {
    return '<li class="' + (klasse ? klasse + ' ' : '') + 'qs-kaarten__item" data-qs-soort="' + soort + '"' +
      (nieuwTab ? '' : ' data-qs-variant="' + esc(variantVan(d.url) || '') + '"') + '>' +
      '<div class="qs-kaarten__kaart">' + eigenKaart(d, soort, nieuwTab) + '</div>' +
      uitlegHTML(d, soort, voor, paginaNr) + '</li>';
  }
  function kaartjesHTML(b, voor, paginaNr, nieuwTab) {
    return '<ul class="qs-kaarten">' + doelen(b).map(function (x) {
      return itemHTML(x[0], x[1], voor, paginaNr, nieuwTab);
    }).join('') + '</ul>';
  }
  // Catalogusnummers die geen kaartje hebben (niet in de winkel, niet bestelbaar of doorgenummerd naar een kaartje).
  function vervangtRest(b) {
    var getoond = {};
    doelen(b).forEach(function (x) { getoond[x[0].url] = 1; });
    return (b.vervangt || []).filter(function (o) { return !(o.url && getoond[o.url]) && !(o.nu && o.nu.url && getoond[o.nu.url]); });
  }
  function vervangtHTML(lijst, nieuwTab) {
    return lijst.map(function (o) {
      var nr = esc(merkNr(o.merk, o.nummer));
      var los = o.url ? '<a href="' + esc(o.url) + '"' + doel(nieuwTab) + '>' + nr + '</a>' : nr;
      var nu = o.nu ? ' <span class="qs-alt__nu">(' + T.nu.replace('{nr}', o.nu.url
        ? '<a href="' + esc(o.nu.url) + '"' + doel(nieuwTab) + '>' + esc(nummer(o.nu.nummer)) + '</a>' : esc(nummer(o.nu.nummer))) + ')</span>' : '';
      return '<li class="qs-alt__oe">' + los + nu + '</li>';
    }).join('');
  }
  function aantalAlt(b) { return doelen(b).length; }
  function altKop(b) { return aantalAlt(b) > 1 ? T.kopMeer : T.kopEen; }
  // Alles voor één product. kop(tekst) maakt een kop boven de kaartjes (null = geen kop: de uitklaprij of het
  // pijltje zegt het al). 'voor' = merk + nummer van dit product; 'paginaNr' = hoe dit product heet (Quicksilver …).
  function blokkenHTML(b, voor, paginaNr, kop, nieuwTab) {
    var h = '';
    var n = aantalAlt(b);
    if (n) h += '<div class="qs-alt__groep">' + (kop ? kop(altKop(b)) : '') + kaartjesHTML(b, voor, paginaNr, nieuwTab) + '</div>';
    var rest = vervangtRest(b);
    if (rest.length) {
      var k = n ? T.kopVervangtOok : T.kopVervangt;
      h += '<div class="qs-alt__groep qs-alt__groep--vervangt">' + (kop || n ? (kop || kopH('h4'))(k) : '') +
        '<ul class="qs-alt__oes">' + vervangtHTML(rest, nieuwTab) + '</ul></div>';
    }
    return h;
  }
  function kopH(niveau) { return function (t) { return '<' + niveau + ' class="qs-alt__kop">' + esc(t) + '</' + niveau + '>'; }; }

  // ── kaartjes van het thema ─────────────────────────────────────────────────
  // /variants/<id> stuurt door naar /products/<handle>?variant=<id> en laat ?view= daarbij vallen. Dus eerst het
  // productadres opzoeken (HEAD, onthouden in sessionStorage), dan het kaartje (?view=qs-kaart).
  // Uitkomst: het themakaartje, of een fout met soort 'weg' (niet (meer) in de winkel of niet beschikbaar: kaartje
  // weghalen), 'uit' (template ontbreekt) of 'tijdelijk' (eigen kaartje laten staan).
  var themaKaarten = {};
  var THEMA = (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '';
  // vlag 'template ontbreekt': per thema en maar 10 minuten, zodat het na het plaatsen van het template snel weer werkt
  var UIT_SLEUTEL = 'qs-kaart-uit-' + THEMA, UIT_GELDIG = 10 * 60 * 1000;
  function opslag(sleutel, waarde) {
    try {
      if (waarde === undefined) return sessionStorage.getItem(sleutel);
      if (waarde === null) sessionStorage.removeItem(sleutel);
      else sessionStorage.setItem(sleutel, waarde);
    } catch (e) { /* privévenster of geblokkeerd: dan elke keer opnieuw */ }
    return null;
  }
  function templateUit() {
    var t = Number(opslag(UIT_SLEUTEL) || 0);
    return !!t && Date.now() - t < UIT_GELDIG;
  }
  function fout(tekst, soort) { var e = new Error(tekst); e.soort = soort; return e; }
  function padSleutel(vid) { return 'qs-pad-' + ROOT + vid; }
  function productAdres(vid, vers) {
    var pad = vers ? null : opslag(padSleutel(vid));
    if (pad) return Promise.resolve({ pad: pad, onthouden: true });
    return fetch(location.origin + ROOT + 'variants/' + vid, { method: 'HEAD', credentials: 'same-origin' }).then(function (r) {
      if (r.status === 404) throw fout('variant ' + vid + ' niet in de winkel', 'weg');
      var p = new URL(r.url).pathname;
      if (!r.ok || p.indexOf('/products/') < 0) throw fout('geen productadres voor variant ' + vid, 'tijdelijk');
      opslag(padSleutel(vid), p);
      return { pad: p, onthouden: false };
    });
  }
  function haalKaart(vid, vers) {
    return productAdres(vid, vers).then(function (a) {
      return fetch(location.origin + a.pad + '?view=qs-kaart&variant=' + vid, { credentials: 'same-origin' }).then(function (r) {
        var anders = r.redirected || new URL(r.url).pathname !== a.pad;
        // onthouden adres verouderd (handle gewijzigd): één keer opnieuw via /variants/
        if (a.onthouden && (r.status === 404 || anders)) { opslag(padSleutel(vid), null); return haalKaart(vid, true); }
        if (r.status === 404) throw fout('product ' + a.pad + ' niet in de winkel', 'weg');
        if (!r.ok) throw fout('kaartje ' + r.status, 'tijdelijk');
        return r.text().then(function (html) {
          if (/<html[\s>]/i.test(html) || html.indexOf('data-qs-kaart') < 0) {
            // alleen als het gevraagde adres zelf de hele pagina gaf (geen doorverwijzing of wachtwoordpagina)
            if (!anders) opslag(UIT_SLEUTEL, String(Date.now()));
            throw fout('template qs-kaart ontbreekt', anders ? 'tijdelijk' : 'uit');
          }
          if (html.indexOf('data-qs-beschikbaar="false"') > -1) throw fout('niet beschikbaar in de winkel', 'weg');
          return html;
        });
      });
    });
  }
  function themaKaart(vid) {
    if (templateUit()) return Promise.reject(fout('template qs-kaart ontbreekt', 'uit'));
    if (!themaKaarten[vid]) themaKaarten[vid] = haalKaart(vid, false);
    return themaKaarten[vid];
  }
  // product-form.js (snel toevoegen) en quick-add.js laadt het thema alleen voor kaartjes die er bij het openen van
  // de pagina al staan (lazy-script bekijkt de pagina één keer). Voor later geplaatste kaartjes zelf laden; beide
  // bestanden beginnen met customElements.get(...), dus dubbel laden kan geen kwaad.
  var THEMA_SCRIPTS = [['product-form', 'product-form'], ['quick-add-modal', 'quick-add']];
  function laadThemaScripts(houder) {
    THEMA_SCRIPTS.forEach(function (x) {
      if (customElements.get(x[0])) return;
      var ls = document.querySelector('lazy-script[src*="/' + x[1] + '.js"]');
      if (ls && typeof ls.loadScript === 'function') { ls.loadScript(); return; }
      var src = houder.getAttribute('data-js-' + x[1]);
      if (!src || document.querySelector('script[data-qs-laad="' + x[1] + '"]')) return;
      var s = document.createElement('script');
      s.src = src; s.defer = true; s.setAttribute('data-qs-laad', x[1]);
      document.head.appendChild(s);
    });
  }
  // ── de prijsapp (BSS) ──────────────────────────────────────────────────────
  // BSS verbergt prijzen tot hij ze verwerkt heeft. Later geplaatste kaartjes bekijkt hij uit zichzelf pas 1 s na een
  // scroll (handleLazyProducts in bss-b2b-v3.js, 21/22-10-2026). Dat stuk doet dit script zelf, zonder die seconde:
  // nieuwe producten laden (productStorage.load) en de prijsronde starten (notifyObserver LazyProduct). Pas na de
  // eigen opstart van de app (isFirstLoad false); duurt die langer dan 6 s, of ontbreken die onderdelen (andere versie
  // van de app), dan het scroll-signaal zoals voorheen.
  function bss() { return window.BSS_B2B; }
  function bssKlaar() {
    var B = bss();
    return !!(B && B.isFirstLoad === false && B.observer && B.observer.productSubject &&
      typeof B.observer.productSubject.notifyObserver === 'function' &&
      B.storage && B.storage.productStorage && typeof B.storage.productStorage.load === 'function');
  }
  // bssOnbekend: product-id's die de app na zijn ronde nog steeds niet kent (bv. niet in de zoekindex van Shopify,
  // waar hij ze ophaalt): die prijst hij nooit, dus niet op wachten.
  var bssPlan = null, bssSinds = 0, bssLoopt = false, bssNogEens = false, bssOnbekend = new Set();
  function bssKent(ps, id) {
    try {
      if (typeof ps.has === 'function') return ps.has(Number(id)) || ps.has(String(id));
      if (ps.store && typeof ps.store.has === 'function') return ps.store.has(Number(id)) || ps.store.has(String(id));
    } catch (e) { /* onbekend hoe te kijken */ }
    return true;   // niet na te gaan: dan niet als onbekend aanmerken (wachten tot de deadline)
  }
  function laatPrijsAppVerwerken() {
    if (!bss()) return;
    if (!bssSinds) bssSinds = Date.now();
    clearTimeout(bssPlan);
    bssPlan = setTimeout(function () {
      if (!bssKlaar()) {
        // nog aan het opstarten: even wachten (tot 6 s); al opgestart maar anders gebouwd (nieuwe versie): meteen
        // het scroll-signaal, dan prijst hij binnen de deadline van het vak
        var opgestart = bss().isFirstLoad === false;
        if (!opgestart && Date.now() - bssSinds < 6000) { laatPrijsAppVerwerken(); return; }
        bssSinds = 0;
        if (opgestart) console.warn('qs-alternatief: prijsapp anders dan verwacht, scroll-signaal gebruikt');
        window.dispatchEvent(new Event('scroll'));
        return;
      }
      bssSinds = 0;
      if (bssLoopt) { bssNogEens = true; return; }   // er loopt al een ronde: daarna nog één voor de nieuwe kaartjes
      bssLoopt = true;
      var B = bss();
      var ps = B.storage.productStorage, subj = B.observer.productSubject;
      Promise.resolve().then(function () { return ps.load(); }).then(function (r) {
        if (r && ((r.notExistProductIds && r.notExistProductIds.length) || (r.productIds && r.productIds.length) ||
            (r.variantIds && r.variantIds.size))) {
          subj.notifyObserver('LazyProduct', 'LoadedLazyProduct', Object.assign({}, r));
          // zoals de app zelf na deze ronde: snel-toevoegen-vensters in de nieuwe kaartjes aan de app koppelen
          if (subj.quickview && typeof subj.quickview.init === 'function') subj.quickview.init();
        }
        ((r && r.notExistProductIds) || []).forEach(function (id) { if (!bssKent(ps, id)) bssOnbekend.add(String(id)); });
      }).catch(function (e) {
        console.warn('qs-alternatief: prijsapp', e);
        window.dispatchEvent(new Event('scroll'));
      }).then(function () {
        bssLoopt = false;
        if (bssNogEens) { bssNogEens = false; laatPrijsAppVerwerken(); }
      });
    }, bssKlaar() ? 30 : 150);
  }
  // Prijs klaar = de prijsapp heeft de prijs berekend en zelf zichtbaar gemaakt. Zonder het script van de app: klaar als
  // de prijs te zien is (staat alleen de verbergregel van de app er, dan nooit: dan het eigen kaartje).
  function prijsKlaar(plek) {
    var items = plek.querySelectorAll('[bss-b2b-product-price], [bss-b2b-variant-price]');
    return !items.length || Array.prototype.some.call(items, function (e) {
      return bss() ? e.style.visibility === 'visible' : getComputedStyle(e).visibility !== 'hidden';
    });
  }
  // De foto mag daarna nog even (FOTO_WACHT ms): het fotovak heeft een vaste maat, dus een late foto vult alleen in.
  var FOTO_WACHT = 600;
  function fotoKlaar(plek) { var f = plek.querySelector('img'); return !f || f.complete; }
  // Een alternatief dat niet (meer) te bestellen is weghalen, en koppen/rij bijwerken.
  function haalWeg(li, houder) {
    li.remove();
    houder.querySelectorAll('.qs-kaarten, .qs-raster').forEach(function (ul) {
      if (!ul.children.length) (ul.closest('.qs-alt__groep') || ul).remove();
    });
    var rij = houder.closest('[data-qs-rij]');
    // verborgen = staat al tussen de winkelresultaten (zoekpagina), telt niet mee
    var n = houder.querySelectorAll('.qs-kaarten__item:not([hidden])').length;
    if (!houder.querySelector('[data-qs-soort="qs"]')) {
      document.querySelectorAll('.qs-alt__melding a').forEach(function (a) { a.remove(); });
    }
    if (!n && !houder.querySelector('.qs-alt__oe')) {
      houder.setAttribute('hidden', '');
      if (rij) rij.setAttribute('hidden', '');
      return;
    }
    if (rij) {
      var kop = rij.querySelector('[data-qs-kop]');
      if (kop) kop.textContent = n > 1 ? T.kopMeer : n ? T.kopEen : T.kopVervangt;
      if (!n) { var sub = houder.querySelector('.qs-alt__groep--vervangt > .qs-alt__kop'); if (sub) sub.remove(); }
    }
  }
  // Het vak verschijnt één keer, af. Terwijl het nog verborgen is komen de themakaartjes erin en berekent de prijsapp
  // hun prijs; dan pas tonen (toon). Wat na KLAAR_UITERLIJK ms nog niet klaar is, krijgt het eenvoudige eigen kaartje
  // (met prijs) terug. Daarna wisselt er niets meer: geen kaartjes die van opmaak of grootte veranderen.
  // De prijsapp kijkt niet of iets zichtbaar is, dus verborgen kaartjes worden gewoon verwerkt.
  // naKaart(li, html): optioneel, zodra het themakaartje binnen is (zoekpagina: dubbele verbergen).
  var KLAAR_UITERLIJK = 4000;
  function themaKaartenEnTonen(houder, toon, naKaart) {
    var lis = Array.prototype.filter.call(houder.querySelectorAll('[data-qs-variant]'), function (li) {
      return !!li.getAttribute('data-qs-variant');
    });
    var eigen = new Map(), open = lis.length, getoond = false, uiterlijk = null;
    function tonen() {
      if (getoond) return;
      getoond = true;
      clearTimeout(uiterlijk);
      eigen.forEach(function (html, li) {
        var plek = li.querySelector('.qs-kaarten__kaart');
        if (plek && !li.classList.contains('qs-kaarten__item--thema')) plek.innerHTML = html;
      });
      toon();
    }
    function afgehandeld() { if (--open <= 0) tonen(); }
    if (!open) { tonen(); return; }
    uiterlijk = setTimeout(tonen, KLAAR_UITERLIJK);
    lis.forEach(function (li) {
      themaKaart(li.getAttribute('data-qs-variant')).then(function (html) {
        var plek = li.querySelector('.qs-kaarten__kaart');
        if (getoond || !plek || !li.isConnected) { afgehandeld(); return; }   // te laat: het eigen kaartje blijft
        eigen.set(li, plek.innerHTML);
        // foto's niet lui laden: het vak is nog verborgen, en lui laden begint pas als iets in beeld komt
        plek.innerHTML = html.replace(/\sloading="lazy"/g, '').replace(/\sfetchpriority="low"/g, '');
        // De prijsapp maakt aan het eind van zijn opstart elke prijs zichtbaar die nog geen eigen 'visibility' heeft,
        // ook als hij hem niet berekend heeft (B2B zou dan de gewone prijs zien). Met 'hidden' erop slaat hij deze
        // over; pas als hij de prijs echt verwerkt zet hij hem zelf op zichtbaar.
        if (bss()) {
          plek.querySelectorAll('[bss-b2b-product-price], [bss-b2b-variant-price]').forEach(function (e) {
            e.style.visibility = 'hidden';
          });
        }
        laadThemaScripts(houder);
        if (naKaart) naKaart(li, html);
        laatPrijsAppVerwerken();
        // Wacht op dit kaartje, behalve als het verborgen is (dubbel op de zoekpagina: dat mag het tonen niet
        // ophouden, maar wordt wel nog themakaartje als het op tijd klaar is) of de prijsapp dit product niet kent.
        var kaartEl = plek.querySelector('[data-qs-kaart]');
        var kaartId = kaartEl ? kaartEl.getAttribute('data-qs-kaart') : '';
        var geteld = false, prijsSinds = 0;
        (function kijk() {
          if (getoond) return;   // te laat: tonen() zet het eigen kaartje terug (ook als het even los van de pagina was)
          if (!prijsSinds && prijsKlaar(plek)) prijsSinds = Date.now();
          if (prijsSinds && (fotoKlaar(plek) || Date.now() - prijsSinds > FOTO_WACHT)) {
            li.classList.add('qs-kaarten__item--thema');
            if (!geteld) afgehandeld();
            return;
          }
          var onbekend = !!kaartId && bssOnbekend.has(kaartId);
          if (!geteld && (li.hidden || onbekend)) { geteld = true; afgehandeld(); }
          if (onbekend) return;
          setTimeout(kijk, 100);
        })();
      }).catch(function (e) {
        if (e.soort === 'weg') haalWeg(li, houder);
        else if (e.soort !== 'uit') console.warn('qs-alternatief', e);
        afgehandeld();
      });
    });
  }

  // ── productpagina ──────────────────────────────────────────────────────────
  // Niet meer leverbaar met een Quicksilver-alternatief (plan B4): koopknop weg, en op die plek een
  // melding met een link naar de uitklaprij "Alternatief" (die staat lager, boven Specificaties).
  function verbergKoopknop(houder, anker) {
    var bereik = houder.closest('.shopify-section') || document;
    // de formulieren in de themakaartjes (snel toevoegen) overslaan: alleen het hoofdformulier van deze pagina
    var knoppen = Array.prototype.filter.call(bereik.querySelectorAll('product-form .product-form__buttons'),
      function (el) { return !el.closest('.qs-alt-rij'); })[0];
    if (knoppen && !bereik.querySelector('.qs-alt__melding')) {
      knoppen.insertAdjacentHTML('beforebegin', '<p class="qs-alt__melding">' + esc(T.nla) +
        ' <a href="#' + esc(anker) + '">' + esc(T.nlaLink) + '</a></p>');
      // zelf scrollen en openklappen: een kale #-link is afhankelijk van de pagina (bv. een <base>-tag)
      bereik.querySelector('.qs-alt__melding a').addEventListener('click', function (e) {
        var rij = document.getElementById(anker);
        if (!rij) return;
        e.preventDefault();
        if (rij.hidden) { rij.setAttribute('data-qs-naar', ''); return; }   // nog aan het laden: erheen zodra hij er staat
        naarRij(rij);
      });
    }
    // alleen de hoofdknop van deze productpagina, niet de snel-toevoegen-knoppen in de kaartjes
    bereik.querySelectorAll('product-form .product-form__buttons, product-form .shopify-payment-button, .product-form__quantity, .sticky-cta')
      .forEach(function (el) {
        if (el.closest('.qs-alt-rij')) return;
        el.setAttribute('hidden', ''); el.style.setProperty('display', 'none', 'important');
      });
    // de vaste balk onderaan doet submitButton.click(): dat werkt ook op een verborgen knop, dus uitschakelen
    bereik.querySelectorAll('product-form [type="submit"], .product-form__submit, .sticky-cta button')
      .forEach(function (b) {
        if (b.closest('.qs-alt-rij')) return;
        b.disabled = true; b.setAttribute('aria-disabled', 'true');
      });
  }
  function naarRij(rij) {
    var details = rij.querySelector('details');
    if (details) details.open = true;
    rij.scrollIntoView({ block: 'start' });   // scroll-margin-top in de CSS houdt hem onder de vaste kop
  }
  function product(houder) {
    var id = houder.getAttribute('data-product-id');
    if (!id) return;
    // de snippet zet de houder in een uitklaprij zoals Specificaties; zonder die rij (oude plaatsing) de houder zelf
    var rij = houder.closest('[data-qs-rij]') || houder;
    haal('/product?id=' + encodeURIComponent(id)).then(function (r) {
      if (!r || !r.product) return;
      var voor = merkNr(r.product.merk, r.product.nummer);
      var h = blokkenHTML(r, voor, naamVan(r.product.merk, r.product.nummer), null);
      if (!h) return;
      var kop = rij.querySelector('[data-qs-kop]');
      if (kop) kop.textContent = aantalAlt(r) ? altKop(r) : T.kopVervangt;
      houder.innerHTML = h;
      // de rij pas tonen als de kaartjes af zijn; intussen kan er een weggevallen zijn (haalWeg)
      themaKaartenEnTonen(houder, function () {
        if (!houder.querySelector('.qs-kaarten__item, .qs-alt__oe')) return;
        houder.removeAttribute('hidden');
        rij.removeAttribute('hidden');
        if (rij.hasAttribute('data-qs-naar')) { rij.removeAttribute('data-qs-naar'); naarRij(rij); }
      });
      if (r.product.niet_leverbaar && r.quicksilver.length) verbergKoopknop(houder, rij.id || 'qs-alternatief');
    }).catch(function (e) { console.warn('qs-alternatief', e); });
  }

  // ── zoekpagina ─────────────────────────────────────────────────────────────
  // In de resultatenkolom, direct onder de productkaartjes van de winkel: een balk "Alternatieven" zoals de balk
  // met het aantal resultaten, en daaronder de kaartjes in het raster van de zoekresultaten (klassen van het thema,
  // vastgesteld op de live zoekpagina 21-10-2026). Alle gevonden producten samen in één raster, elk alternatief één
  // keer. Catalogusnummers zonder kaartje alleen op de productpagina.
  var BALK = 'color-scheme-2 gradient border-radius-panel p-2 pl-3 box-content card--shadow mb-2';
  var RASTER = 'grid product-grid grid--2-col-tablet-down grid--3-col-desktop grid--scaled mt-0';
  // de productkaartjes van de winkel zelf (niet die van dit script, die hebben ook .product-grid)
  function inWinkelResultaten(selector) {
    return Array.prototype.some.call(document.querySelectorAll('#ProductGridContainer ul.product-grid'), function (ul) {
      return !ul.closest('.qs-alt') && !!ul.querySelector(selector);
    });
  }
  function alsSelector(s) { return window.CSS && CSS.escape ? CSS.escape(s) : s; }
  // handle van een alternatief: uit het themakaartje, anders uit het onthouden productadres (zie productAdres)
  function handleVan(li) {
    var h = li.getAttribute('data-qs-handle');
    if (h) return h;
    var m = /\/products\/([^\/?#]+)/.exec(opslag(padSleutel(li.getAttribute('data-qs-variant'))) || '');
    return m ? m[1] : null;
  }
  // Een alternatief dat al tussen de winkelresultaten staat (bv. omdat zijn beschrijving het gezochte nummer noemt)
  // verbergen; het vak alleen tonen als er iets overblijft. Opnieuw na filteren, sorteren of "meer laden": wat dan
  // uit de resultaten verdwijnt komt hier terug. Alleen attributen: de MutationObserver (childList) reageert er niet op.
  function werkZoekBij(houder) {
    var over = 0;
    houder.querySelectorAll('.qs-raster > .qs-kaarten__item').forEach(function (li) {
      var vid = li.getAttribute('data-qs-variant'), handle = handleVan(li);
      var dubbel = !!(vid && inWinkelResultaten('input[name="id"][value="' + vid + '"]')) ||
        !!(handle && inWinkelResultaten('[data-product-handle="' + alsSelector(handle) + '"]'));
      if (li.hidden !== dubbel) li.hidden = dubbel;
      if (!dubbel) over++;
    });
    if (houder.hidden !== !over) houder.hidden = !over;
  }
  // Ergens na .template-search__results (het raster van de winkel) in dezelfde kolom, ook bij 0 resultaten; niet per
  // se direct erna, dan kan het niet touwtrekken met iets anders dat daar wil staan. Uitkomst: 0 = geen
  // resultatenkolom, 1 = staat goed, 2 = verplaatst.
  function onderResultaten(houder) {
    var bak = document.getElementById('ProductGridContainer');
    if (!bak) return 0;
    var res = bak.querySelector('.template-search__results');
    if (res) {
      if (houder.parentNode === res.parentNode && (res.compareDocumentPosition(houder) & Node.DOCUMENT_POSITION_FOLLOWING)) return 1;
      res.insertAdjacentElement('afterend', houder);
      return 2;
    }
    var eerste = bak.firstElementChild;
    var plek = eerste && eerste !== houder ? eerste : bak;
    if (plek.contains(houder)) return 1;
    plek.appendChild(houder);
    return 2;
  }
  // Filteren of sorteren vervangt de inhoud van #ProductGridContainer (facets.js), de theme editor soms de hele bak:
  // dan het vak, met de al geladen kaartjes, opnieuw neerzetten. Daarom document.body in de gaten houden.
  function zetOnderResultaten(houder) {
    if (!onderResultaten(houder)) return;   // ander thema: het vak blijft op zijn eigen plek boven de resultaten
    houder.classList.add('qs-alt--in-resultaten');
    var verplaatst = [];
    var obs = new MutationObserver(function () {
      if (onderResultaten(houder) === 2) {
        var nu = Date.now();
        verplaatst = verplaatst.filter(function (t) { return nu - t < 2000; }).concat(nu);
        // noodrem: blijft iets het vak wegduwen, dan stoppen in plaats van de pagina te laten vastlopen
        if (verplaatst.length > 20) { obs.disconnect(); console.warn('qs-alternatief: vak blijft verplaatst worden, gestopt'); return; }
      }
      werkZoekBij(houder);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  // Eén vak per pagina: twee houders zouden elkaar eindeloos van de plek onder de resultaten duwen.
  var zoekGestart = false;
  function zoek(houder) {
    if (zoekGestart) return;
    zoekGestart = true;
    var q = (houder.getAttribute('data-q') || '').trim();
    if (!/\d/.test(q) || q.replace(/[^0-9A-Za-z]/g, '').length < 4 || q.length > 40) return;
    haal('/zoek?q=' + encodeURIComponent(q)).then(function (r) {
      if (!r || !r.resultaten || !r.resultaten.length) return;
      var gezien = {}, items = '';
      r.resultaten.forEach(function (x) {
        var p = x.product;
        doelen(x).forEach(function (y) {
          var d = y[0], sleutel = d.url || d.merk + ' ' + d.nummer;
          if (gezien[sleutel]) return;
          gezien[sleutel] = 1;
          items += itemHTML(d, y[1], merkNr(p.merk, p.nummer), naamVan(p.merk, p.nummer), false, 'grid__item');
        });
      });
      if (!items) return;
      // product-count__text: alleen voor de opmaak; facets.js werkt met .js-product-count, niet met deze klasse
      houder.innerHTML = '<div class="qs-alt__balk ' + BALK + '"><h2 class="qs-alt__balktitel product-count__text font-medium text-body">' +
        esc(T.zoekKop) + '</h2></div><ul class="qs-raster ' + RASTER + '" role="list">' + items + '</ul>';
      // qs-alt--laden: nog niet te zien tot de kaartjes af zijn (themaKaartenEnTonen)
      houder.classList.add('qs-alt--laden');
      zetOnderResultaten(houder);
      werkZoekBij(houder);   // zichtbaar of niet (als alles al tussen de resultaten staat), zodra het laden klaar is
      themaKaartenEnTonen(houder, function () { houder.classList.remove('qs-alt--laden'); }, function (li, html) {
        var m = /data-product-handle="([^"]+)"/.exec(html);
        if (m) li.setAttribute('data-qs-handle', m[1]);
        werkZoekBij(houder);
      });
    }).catch(function (e) { console.warn('qs-alternatief', e); });
  }

  // ── part scanner ───────────────────────────────────────────────────────────
  // De scanner zet na elke gekozen motor [motorId, /parts-antwoord, merk] in window.tekeningenWacht.
  // Uit dat antwoord: artikelnummer -> catalogus-id; de kaarten tonen het nummer in .an.
  var scan = { motor: null, merk: '', perNr: {}, alt: null, gestart: false };
  var SCAN_STUK = 1000;   // id's per aanvraag (de functie neemt er hoogstens 2.500)
  function kaal(s) { return String(s || '').toUpperCase().replace(/[^0-9A-Z]/g, ''); }
  function scannerMotor() {
    var w = window.tekeningenWacht;
    var laatste = w && w.length ? w[w.length - 1] : null;
    if (!laatste || !laatste[1] || !laatste[1].diagrammen) return;
    if (laatste[0] === scan.motor) return;
    scan.motor = laatste[0]; scan.merk = laatste[2] || ''; scan.perNr = {}; scan.alt = null;
    // per nummer alle id's (dubbele catalogusrecords); een onderdeel staat vaak op meer tekeningen
    var gezien = {}, ids = [];
    laatste[1].diagrammen.forEach(function (dg) {
      (dg.onderdelen || []).forEach(function (o) {
        var nr = kaal(o.artikelnummer);
        if (!o.id || !nr) return;
        var lijst = scan.perNr[nr] || (scan.perNr[nr] = []);
        if (lijst.indexOf(o.id) < 0) lijst.push(o.id);
        if (!gezien[o.id]) { gezien[o.id] = 1; ids.push(o.id); }
      });
    });
    if (!ids.length) return;
    var motor = scan.motor, delen = [];
    for (var i = 0; i < ids.length; i += SCAN_STUK) delen.push(ids.slice(i, i + SCAN_STUK));
    Promise.all(delen.map(function (deel) {
      return haal('/scanner', {
        method: 'POST', headers: { apikey: KOP.apikey, 'Content-Type': 'text/plain' },
        body: JSON.stringify({ ids: deel })
      });
    })).then(function (antwoorden) {
      if (motor !== scan.motor) return;
      var alt = {};
      antwoorden.forEach(function (r) {
        var per = (r && r.per_id) || {};
        Object.keys(per).forEach(function (k) { alt[k] = per[k]; });
      });
      scan.alt = alt;
      versier();
    }).catch(function (e) {
      console.warn('qs-alternatief', e);
      if (motor === scan.motor) scan.motor = null;   // bij de volgende wijziging of keuze opnieuw proberen
    });
  }
  function versier() {
    if (!scan.alt) return;
    document.querySelectorAll('.bw-parts .kaart, .bw-parts .rij').forEach(function (el) {
      if (el.getAttribute('data-qs') === scan.motor) return;
      el.setAttribute('data-qs', scan.motor);
      var oud = el.querySelectorAll('.qs-scan');
      oud.forEach(function (x) { x.remove(); });
      var an = el.querySelector('.an');
      var kandidaten = (an && scan.perNr[kaal(an.textContent)]) || [];
      var id = kandidaten.filter(function (x) { return scan.alt[x]; })[0];
      var b = id && scan.alt[id];
      if (!b) return;
      var n = aantalAlt(b);
      var voor = (scan.merk ? scan.merk + ' ' : '') + an.textContent.trim();
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'qs-scan qs-scan__pijl';
      knop.setAttribute('aria-expanded', 'false');
      knop.innerHTML = '<span class="qs-scan__driehoek" aria-hidden="true"></span>' + esc(n > 1 ? T.pijlMeer.replace('{n}', n) : T.pijl);
      var vak = document.createElement('div');
      vak.className = 'qs-scan qs-scan__vak qs-alt';
      vak.hidden = true;
      vak.innerHTML = blokkenHTML(b, voor, voor, null, true);
      if (el.classList.contains('rij')) {
        // lijstrij: de naamcel is één regel; knop + vak op een eigen regel over de volle breedte
        var regel = document.createElement('div');
        regel.className = 'qs-scan qs-scan__rij';
        regel.appendChild(knop);
        regel.appendChild(vak);
        el.appendChild(regel);
      } else {
        var na = el.querySelector('.oud') || an;
        na.insertAdjacentElement('afterend', knop);
        knop.insertAdjacentElement('afterend', vak);
      }
    });
  }
  function scanner() {
    if (scan.gestart) return;      // één keer per pagina, ook bij meer scanner-houders
    scan.gestart = true;
    // klik op het pijltje: vakje open/dicht, zonder dat de kaart of rij zelf reageert
    document.addEventListener('click', function (e) {
      var knop = e.target.closest && e.target.closest('.qs-scan__pijl');
      if (knop) {
        e.preventDefault(); e.stopPropagation();
        var vak = knop.parentElement.querySelector('.qs-scan__vak');
        var open = knop.getAttribute('aria-expanded') !== 'true';
        knop.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (vak) vak.hidden = !open;
        return;
      }
      if (e.target.closest && e.target.closest('.qs-scan__vak') && !e.target.closest('a')) e.stopPropagation();
    }, true);
    var wacht = null;
    new MutationObserver(function () {
      if (wacht) return;
      wacht = setTimeout(function () { wacht = null; scannerMotor(); versier(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
    scannerMotor();
  }

  // Elke houder één keer (data-qs-klaar): bij het laden, als het script opnieuw draait, en nadat de theme editor
  // een sectie opnieuw getekend heeft (shopify:section:load).
  function init() {
    document.querySelectorAll('[data-qs-alt]:not([data-qs-klaar])').forEach(function (h) {
      h.setAttribute('data-qs-klaar', '');
      instellingen(h);
      var soort = h.getAttribute('data-qs-alt');
      if (soort === 'product') product(h);
      else if (soort === 'zoek') zoek(h);
      else if (soort === 'scanner') scanner();
    });
  }
  window.qsAlternatief = { versie: '2026-10-22-in-een-keer', init: init };
  document.addEventListener('shopify:section:load', init);
  init();
})();
